import { Box, styled } from '@mui/material'

export const FormRow = styled(Box)(({ theme }) => ({
  margin: `${theme.spacing(2)} 0 0 0!important`,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
}))
